import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/IMT_logo.png';
import './legal.css';

/**
 * Placeholder Impressum (legal notice) page (audit 2026-05-17).
 * Required by section 5 of the German Digitale-Dienste-Gesetz (DDG).
 * Real content (registered address, commercial register, VAT ID,
 * managing directors, responsible editor) to be supplied by IMT International Trading AG Legal.
 */
function Impressum() {
  return (
    <div className="legal-page">
      <img src={logo} alt="IMT" className="legal-page__logo" />
      <div className="legal-page__card">
        <div className="legal-page__branding">
          <h1 className="legal-page__company">IMT International Trading AG</h1>
          <h2 className="legal-page__title">Impressum / Legal Notice</h2>
        </div>
        <div className="legal-page__body">
          <p>
            Verantwortlich fur den Inhalt im Sinne von 5 DDG / Responsible for
            content per section 5 DDG:
          </p>
          <p>
            IMT International Trading AG
            <br />
            Full registered address, commercial register number, VAT ID,
            managing directors and responsible editor details are being
            confirmed and will appear here.
          </p>
        </div>
        <div className="legal-page__contact">
          General contact: to be confirmed by Legal
        </div>
        <Link to="/login" className="legal-page__back">
          Back to login
        </Link>
      </div>
    </div>
  );
}

export default Impressum;
